export default "__VITE_ASSET__CjDuOr95__"